import { getCurrentCountry, getCurrentCulture } from '@vp/culture-resolution';

const queryParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');

export const currentCountry = queryParams.get('country') || getCurrentCountry();
export const currentCulture = queryParams.get('culture') || getCurrentCulture();
export const currentLanguage = currentCulture.split('-')[0];
